// @ts-nocheck BaseHeader type does not support zIndex or spreading of props. Fix it in the adapter and the remove this comment
import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { themeGet } from '@styled-system/theme-get';

import { config } from '@xingternal/hops';

import { Header as BaseHeader, UserNav } from '@ui/wrapper';
import { paths } from '@infrastructure/routing/paths';

const HeaderWrapper = styled.header`
  position: relative;
  width: 100%;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  && {
    z-index: ${themeGet('zIndices.sidebarLevel')};
  }
`;

// Why do we need this?
const noop = () => undefined;

type HeaderProps = {
  userName: string;
  userAvatarUrl: string;
  userCompany: string;
  userEmail: string;
};

const Header = (props: HeaderProps) => {
  const { locale } = useIntl();

  const { userName, userAvatarUrl, userCompany, userEmail } = props;

  return (
    <HeaderWrapper data-testid="app-header">
      <BaseHeader
        currentApp="xss"
        lang={locale}
        zIndex={2}
        trackingExternalOnClick={noop}
        trackingUrlParam=""
      >
        <UserNav
          name={userName}
          avatarUrl={userAvatarUrl}
          company={userCompany}
          mail={userEmail}
          onAvatarClick={noop}
          tooltipPosition="top"
        >
          <UserNav.Settings
            data-testid="settings-button"
            onClick={() => window.location.assign(paths.recruitingSettings)}
          />
          <UserNav.Help
            data-testid="help-button"
            href={paths.helpCommunityLink(locale)}
          />
          <UserNav.Logout
            data-testid="logout-button"
            onClick={() => window.location.assign(config.logoutUri)}
          />
        </UserNav>
      </BaseHeader>
    </HeaderWrapper>
  );
};

export { Header };
